import { useDebounce } from "use-debounce";

// Debounces a search term so downstream API queries don't fire on every
// keystroke (OPTI-6664). `isDebouncePending` lets callers OR-in a loading
// state while the debounce window is open so the UI doesn't show stale
// results between keystrokes.
export const useDebouncedTerm = (
  term: string,
  delayMs: number = 500,
): { debouncedTerm: string; isDebouncePending: boolean } => {
  const [debouncedTerm] = useDebounce(term, delayMs);
  return {
    debouncedTerm,
    isDebouncePending: term !== debouncedTerm,
  };
};
